import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { CompanyService } from '../../../rent/service/data/company.service';
import { ReportService } from '../../service/data/report.service';
import { Subscription } from 'rxjs';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { ArticleService } from '../../../rent/service/data/article.service';
import { LocalDate } from '../../../core/model/local-date';
import { SelectionItem } from '../../../core/component/select/select.component';
import { canSubmitReportForm } from '../../utility/report-form-validation';

@Component({
    selector: 'tax-reduction-report',
    templateUrl: './tax-reduction-report.component.html',
    styleUrls: ['./tax-reduction-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TaxReductionReportComponent implements OnDestroy, OnInit {
  constructor(
    private _cdf: ColumnDefinitionFactory,
    private _companyService: CompanyService,
    private _articleService: ArticleService,
    private _dataService: ReportService,
    private _nativeWindow: NativeWindowService,
    fb: FormBuilder,
    fcf: FormControlExFactory
  ) {
    const fromDate = LocalDate.fromDate(LocalDate.fromDate(LocalDate.today().addMonths(-1)).firstDayInMonth());
    const toDate = LocalDate.fromDate(fromDate.lastDayInMonth());

    this.form = fb.group({
      company: fcf.createMandatory('COMMON.COMPANY', null),
      articleId: fcf.createMandatory('ARTICLE.EDIT_HEADER', null),
      periodFrom: fcf.createMandatory('INVOICE.PERIOD_FROM', fromDate),
      periodTo: fcf.createMandatory('INVOICE.PERIOD_TO', toDate),
    });
  }

  form: FormGroup;
  private _subscription: Subscription;
  companies: SelectionItem[];
  articles: SelectionItem[];

  ngOnInit() {
    this._companyService.getList().subscribe(data => {
      this.companies = data.map(item => new SelectionItem(item.name, item.id));

      if (this.companies.length) {
        this.form.controls['company'].setValue(this.companies[0].value);
      }
    });

    this._articleService.getList().subscribe(data => {
      this.articles = data.map(item => new SelectionItem(item.toString(), item.id));

      if (this.articles.length) {
        this.form.controls['articleId'].setValue(this.articles[0].value);
      }
    });
  }

  ngOnDestroy(): void {
    if (this._subscription) this._subscription.unsubscribe();
  }

  exportToExcel(): void {
    if (!canSubmitReportForm(this.form)) return;

    if (this._subscription) this._subscription.unsubscribe();

    this._subscription = this._dataService.getTaxReductionReport(this.form.value).subscribe(file => {
      this._nativeWindow.save(file);
    });
  }

  exportToXML(): void {
    if (!canSubmitReportForm(this.form)) return;

    if (this._subscription) this._subscription.unsubscribe();

    this._subscription = this._dataService.getTaxReductionReportXML(this.form.value).subscribe(file => {
      this._nativeWindow.save(file);
    });
  }

  onSubmit() {
    if (!canSubmitReportForm(this.form)) return;

    this._subscription = this._dataService.getTaxReductionReport(this.form.value).subscribe(file => {
      this._nativeWindow.save(file);
    });
  }
}
